/** Map API receipt / core txn shapes to Smart Ledger token cards. */
export function receiptDocToToken(doc) {
  const core = doc.itemiz_core || {};
  const merchant =
    core.merchant_name ||
    doc.line_items?.[0]?.merchant ||
    'Verified merchant';

  const items = (doc.line_items || []).map((row, i) => ({
    sku: row.sku || row.id || `L${i}`,
    description: row.name || row.description || 'Item',
    qty: row.qty || row.quantity || 1,
    unit: (row.unit_price_cents ?? row.price ?? 0) / (row.unit_price_cents != null ? 100 : 1),
    total: (row.total_cents ?? row.price ?? 0) / (row.total_cents != null ? 100 : 1),
  }));

  return {
    id: core.transaction_id || doc.receipt_id,
    merchant,
    date: (doc.minted_at || '').split('T')[0] || new Date().toISOString().split('T')[0],
    total: String((doc.amount_cents || 0) / 100),
    persona: core.persona || '',
    bankTxId: core.column_transfer_id || '—',
    verified: true,
    receiptId: doc.receipt_id,
    proofUrl: doc.proof_of_truth_url,
    auditSignature: core.audit_signature || null,
    items: items.length ? items : [{ sku: '—', description: 'Itemized receipt', qty: 1, unit: 0, total: 0 }],
  };
}

export function coreTxnToToken(txn) {
  return {
    id: txn.transactionId,
    merchant: txn.merchantName,
    date: txn.settledAt
      ? new Date(txn.settledAt).toISOString().split('T')[0]
      : new Date().toISOString().split('T')[0],
    total: txn.totalAmount,
    persona: txn.persona || '',
    bankTxId: txn.bankTxId || '—',
    verified: txn.status === 'VERIFIED_TRUTH',
    auditSignature: txn.auditSignature || null,
    items: (txn.items || []).map((item, i) => ({
      sku: item.sku || `SKU-${i}`,
      description: item.description || 'Line item',
      qty: item.quantity || 1,
      unit: item.unit_price ?? item.unit_price ?? 0,
      total: item.total_price ?? 0,
    })),
  };
}

export function mergeTokens(...lists) {
  const map = new Map();
  for (const list of lists) {
    for (const t of list) {
      if (t?.id) map.set(t.id, t);
    }
  }
  return [...map.values()].sort((a, b) => (b.date || '').localeCompare(a.date || ''));
}
